module.exports = __webpack_public_path__ + "assets/img/e75eecb23f7d8775174f4d1a68e6f1c3.png";